import React, { Component, useEffect } from "react";
import { Col, Row, Alert, Button } from "react-bootstrap";
import { Query } from "react-apollo";
import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import WrappedUp from "../containers/WrappedUp";
import AccountList from "../components/AccountList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import {
  getGoogleLink,
  getGoogleToken,
  getGoogleSheetsStatus
} from "../../api/queries/comptes.queries";
import { logout, useAuthDispatch, useAuthState } from "../Context";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function LogoutPage(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const userDetails = useAuthState(); //read user details from context

  useEffect(() => {
    logout(dispatch); //call the logout action

    navigate(0); //navigate to dashboard on success
  }, []); // <-- empty dependency array

  const location = useLocation();

  return <>Chargement...</>;
}

export default LogoutPage;
